var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"#000","strokeWidth":"2"},React.createElement("path",{"d":"M20 12H2M14 20.005l8-8-8-8"})));
}

ArrowInline.defaultProps = {"width":"24","height":"24"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
